import { defineMessages } from 'react-intl';

export default defineMessages({
  tableProgressLoadingMessage: {
    id: 'common.tableProgress.default.loading.message',
    defaultMessage: 'Loading...',
  },
});
